module.exports = __webpack_public_path__ + "static/icon-laptop-374a340d1b6babc6f9c42937e97b7415.png";